// extracted by mini-css-extract-plugin
module.exports = {"tile":"LocalTile_tile__1UIOB"};